import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconCloseSmall = /*@__PURE__*/ proxyCustomElement(class CosmosIconCloseSmall extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '98ea21b5e707e9159c1d98fe90901446a205b12b', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'e029a6c378653791b1d5f3e321ebf6ef08a98fc9', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '09361552a661d16074e3f5ded9d2d2e8eb21b40b', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15.773 14.712 12.061 11l3.712-3.712a.5.5 0 0 0 0-.707l-.354-.354a.5.5 0 0 0-.707 0L11 9.939 7.288 6.227a.5.5 0 0 0-.707 0l-.354.354a.5.5 0 0 0 0 .707L9.939 11l-3.712 3.712a.5.5 0 0 0 0 .707l.354.354a.5.5 0 0 0 .707 0L11 12.061l3.712 3.712a.5.5 0 0 0 .707 0l.354-.354a.5.5 0 0 0 0-.707", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-close-small", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-close-small"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-close-small":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconCloseSmall);
            }
            break;
    } });
}

export { CosmosIconCloseSmall as C, defineCustomElement as d };
